import { alpha } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import { isDark } from '../../../global/styles';

export const TaskBannerContainer = styled('div', {
  shouldForwardProp: (prop) => !['noSelect', 'isDisabled'].includes(prop),
})(({ theme, noSelect, isDisabled }) => ({
  flex: 'auto',
  backgroundColor: alpha(theme.palette.primary.main, 0.25),
  '@media print': {
    display: 'none',
  },
  ...(noSelect && {
    backgroundColor: isDark(theme) ? alpha(theme.palette.common.black, 0.15) : alpha(theme.palette.common.white, 0.15),
  }),
  ...(isDisabled && {
    color: alpha(theme.palette.text.secondary, 0.5),
  }),
}));

export const InnerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginRight: theme.spacing(1),
  marginLeft: theme.spacing(1),
  height: 74,
}));

export const AddButton = styled('span')(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

export const FormControlOverride = styled('div')({
  marginRight: 0,
  marginLeft: 0,
});

export const StyledCheckboxWrap = styled('span')(({ theme }) => ({
  marginLeft: -7,
  color: theme.palette.text.primary,
}));
